import React, { useState, useCallback } from 'react';
import { today } from '../../data/constants';
import AnalyticsOverview from './analytics/AnalyticsOverview';
import AnalyticsUsers from './analytics/AnalyticsUsers';
import AnalyticsOrders from './analytics/AnalyticsOrders';
import AnalyticsListings from './analytics/AnalyticsListings';
import AnalyticsActivity from './analytics/AnalyticsActivity';

const TABS = [
    { key: 'overview', label: 'Overview' },
    { key: 'users', label: 'Users & Growth' },
    { key: 'orders', label: 'Orders' },
    { key: 'listings', label: 'Listings' },
    { key: 'activity', label: 'Activity' },
];

const QUICK_FILTERS = [
    { key: '7d', label: '7 Days' },
    { key: '30d', label: '30 Days' },
    { key: '90d', label: '90 Days' },
    { key: '1y', label: '1 Year' },
    { key: 'lifetime', label: 'Lifetime' },
    { key: 'custom', label: 'Custom' },
];

function AdminAnalytics() {
    const [activeTab, setActiveTab] = useState('overview');
    const [filter, setFilter] = useState('30d');
    const [customStart, setCustomStart] = useState('');
    const [customEnd, setCustomEnd] = useState('');

    const buildQuery = useCallback(() => {
        let q = `filter=${filter}`;
        if (filter === 'custom' && customStart && customEnd) {
            q += `&startDate=${customStart}&endDate=${customEnd}`;
        }
        return q;
    }, [filter, customStart, customEnd]);

    const renderTab = () => {
        const q = buildQuery();
        switch (activeTab) {
            case 'overview': return <AnalyticsOverview query={q} />;
            case 'users': return <AnalyticsUsers query={q} />;
            case 'orders': return <AnalyticsOrders query={q} />;
            case 'listings': return <AnalyticsListings query={q} />;
            case 'activity': return <AnalyticsActivity query={q} />;
            default: return null;
        }
    };

    return (
        <div className="adminAnalyticsDiv">
            <div className="analyticsHeader">
                <h1 className="primaryHeading"><span>Platform</span> Analytics</h1>
                <div className="analyticsFilterBar">
                    <div className="quickFilters">
                        {QUICK_FILTERS.map(f => (
                            <button key={f.key} className={`filterPill${filter === f.key ? ' active' : ''}`} onClick={() => setFilter(f.key)}>{f.label}</button>
                        ))}
                    </div>
                    {filter === 'custom' && (
                        <div className="customDateRange">
                            <label>From</label>
                            <input type="date" value={customStart} onChange={e => setCustomStart(e.target.value)} max={today} />
                            <label>To</label>
                            <input type="date" value={customEnd} onChange={e => setCustomEnd(e.target.value)} max={today} />
                        </div>
                    )}
                </div>
            </div>
            <div className="analyticsTabs">
                {TABS.map(t => (
                    <button key={t.key} className={`analyticsTab${activeTab === t.key ? ' active' : ''}`} onClick={() => setActiveTab(t.key)}>{t.label}</button>
                ))}
            </div>
            <div className="analyticsTabContent">
                {renderTab()}
            </div>
        </div>
    );
}

export default AdminAnalytics;
